import type { HttpPatch } from '@/shared/infra/http'
import type { EditAnnouncement } from '@/modules/connect/use-cases'
import { mapConnectError } from './map-connect-error'
import { type AnnouncementDto, toAnnouncement } from './announcement-dto'

type EditAnnouncementResponseDto = {
  announcement: AnnouncementDto
}

export class EdgeEditAnnouncementRepository {
  constructor(private readonly http: HttpPatch) {}

  execute: EditAnnouncement = async (params) => {
    try {
      const data = await this.http.patch<unknown, EditAnnouncementResponseDto>({
        url: `/connect/announcements/${encodeURIComponent(params.announcementId)}`,
        body: {
          orgId: params.orgId,
          orgType: params.orgType,
          title: params.title,
          body: params.body,
        },
      })
      return { announcement: toAnnouncement(data.announcement) }
    } catch (err) {
      throw mapConnectError(err)
    }
  }
}
